const colors = [
    {
        primary: '#D2E0FB',
        secondary: '#528ff6',
    },
    {
        primary: '#FFF2CC',
        secondary: '#ffd645',
    },
    {
        primary: '#E5E0FF',
        secondary: '#313bb2',
    },
    {
        primary: '#CDF0EA',
        secondary: '#6eccb8',
    },
    {
        primary: '#F4DADA',
        secondary: '#ca696a',
    },
    {
        primary: '#F6E5F5',
        secondary: '#bb44b8',
    },
    {
        primary: '#ccf4c7',
        secondary: '#52d34d',
    },
];

export default colors;
